<div class="content-container">
    <h4 class="revizie">Revizia 2 / 02.12.2024</h4>
    <br>
    <h1>ACORDUL PACIENTULUI INFORMAT</h1>
    <p>*Tabel cu personalul medical
        care acordă îngrijiri de sănătate d-nei/d-rei/d-lui <b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_prenumePacient)}} {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_numePacient)}}</b>.</p>

    <!-- Personal medical-->
    <table>
        <tr class="leftAlignHead">
            <td style="width: 0.5cm; text-align: center">Nr. crt.</td>
            <td>Nume și prenume</td>
            <td>Profesie</td>
            <td>Grad profesional / specialitate</td>
        </tr>
        <tr *ngFor="let person of getStaffInfo(); let i=index;">
            <ng-container *ngIf="person">
                <td><b>{{i+1}}</b></td>
                <td>{{person.numeSiPrenume}}</td>
                <td>{{person.profesie}}</td>
                <td>{{person.gradSpecialitate}}</td>
            </ng-container>
        </tr>
    </table>

    <table style="margin-top: 0.2cm">
        <tr class="leftAlignHead">
            <td colspan="2">1. Date pacient</td>
        </tr>
        <tr>
            <td style="width: 6cm">1.1. Nume și prenume:</td>
            <td><b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_prenumePacient)}} {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_numePacient)}}</b></td>
        </tr>
        <tr>
            <td>1.2. Domiciliu/reședință:</td>
            <td><b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_addrPacient)}}</b></td>
        </tr>
        <tr class="leftAlignHead">
            <td colspan="2">2. Reprezentantul legal al pacientului*<br>
                *Se utilizează în cazul minorilor sau al majorilor fără discernământ</td>
        </tr>
        <tr>
            <td>2.1. Nume și prenume:</td>
            <td><b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_prenumeLegalPers)}} {{getFieldData(BasicInfoFieldNames.basic_numeLegalPers)}}</b></td>
        </tr>
        <tr>
            <td>2.2. Domiciliu/reședință:</td>
            <td><b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_addrLegalPers)}}</b></td>
        </tr>
        <tr>
            <td>2.3 Calitate:</td>
            <td><b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_tipPersoana)}}</b></td>
        </tr>
        <tr class="leftAlignHead">
            <td>3. Actul medical (descriere)</td>
            <td style="background-color: white"> {{getFieldData(GeneralFieldNames.clinic_act_medical)}}</td>
        </tr>
    </table>

    <table>
        <tr class="leftAlignHead">
            <td>4. Au fost furnizate pacientului următoarele informații în legătura cu actul medical:</td>
            <td>DA</td>
            <td>NU</td>
        </tr>
        <tr>
            <td>4.1. Date despre starea de sănătate</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.2. Diagnostic</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info2_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info2_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.3 Prognostic</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info3_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info3_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.4. Natura și scopul actului medical propus</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info4_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info4_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.5. Intervențiile și strategia terapeutică propuse</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info5_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info5_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.6. Beneficiile și consecințele actului medical, insistându-se asupra următoarelor:<br>
                <i><b>{{getFieldData(AcordPacientInformatFieldNames.API_SB_V2__info6extra_4)}}</b></i>
            </td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info6_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info6_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.7. Riscurile potențiale ale actului medical, insistându-se asupra următoarelor:<br>
                <i><b>{{getFieldData(AcordPacientInformatFieldNames.API_SB_V2__info7extra_4)}}</b></i>
            </td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info7_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info7_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.8. Alternative viabile de tratament și riscurile acestora, insistându-se asupra următoarelor:<br>
                <i><b>{{getFieldData(AcordPacientInformatFieldNames.API_SB_V2__info8extra_4)}}</b></i>
            </td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info8_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info8_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.9. Riscurile neefectuării tratamentului</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info9_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info9_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.10. Riscurile nerespectării recomandărilor medicale</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info10_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info10_4,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>4.11. Prețul de cost estimativ al actului medical</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info11_4,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info11_4,  "X", true)}}</b></td>
        </tr>
        <tr class="leftAlignHead">
            <td>5. Consimțământ pentru recoltare</td>
            <td>DA</td>
            <td>NU</td>
        </tr>
        <tr>
            <td>5.1. Pacientul este de acord cu recoltarea, păstrarea și folosirea produselor biologice, natura și
                scopul acestora fiind explicate pe înțelesul său:</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_5,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_5,  "X", true)}}</b></td>
        </tr>
        <tr class="leftAlignHead">
            <td>6. Alte informații care au fost furnizate pacientului</td>
            <td>DA</td>
            <td>NU</td>
        </tr>
        <tr>
            <td>6.1. Informații despre serviciile medicale disponibile</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_6,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_6,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>6.2. Informații despre identitatea și statutul profesional al personalului care îl va trata*<br>
                *Identificat în tabelul cu personalul medical care acordă îngrijiri de sănătate pacientului</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info2_6,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info2_6,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>6.3. Informații despre regulile/practicile din unitatea medicală, pe care trebuie să le respecte</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info3_6,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info3_6,  "X", true)}}</b></td>
        </tr>
        <tr>
            <td>6.4. Pacientul a fost încunoștințat că are dreptul la o a doua opinie medicală</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info4_6,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info4_6,  "X", true)}}</b></td>
        </tr>
        <tr class="leftAlignHead">
            <td>7. Pacientul dorește să fie informat în continuare despre starea sa de sănătate</td>
            <td>DA</td>
            <td>NU</td>
        </tr>
        <tr>
            <td></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_7,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_7,  "X", true)}}</b></td>
        </tr>
        <tr class="leftAlignHead">
            <td>8. Consimțământ pentru efectuarea următoarelor investigații paraclinice</td>
            <td>DA</td>
            <td>NU</td>
        </tr>
        <tr>
            <td>{{getDescriptionInvestParaclinice()}}</td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_8,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_8,  "X", true)}}</b></td>
        </tr>
        <!--        <tr>-->
        <!--            <td>Radiografie panoramică - pentru evaluarea generală a arcadelor dentare, sinusurilor maxilare și articulațiilor temporo-mandibulare.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Radiografie retroalveolară - pentru detalii mai precise ale unor dinți individuali.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info2_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info2_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Radiografie bite-wing - utilă pentru identificarea cariilor interdentare și evaluarea densității osoase.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info3_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info3_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Test microbiologic - pentru detectarea bacteriilor implicate în afecțiuni precum parodontita sau abcesele dentare.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info4_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info4_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Cultura fungică - mai ales în cazurile de stomatită candidală.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info5_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info5_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Testare la alergii - pentru pacienții care pot avea reacții alergice la materiale dentare sau medicamente.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info6_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info6_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Analize de sânge: Hemoleucogramă completă (pentru a detecta eventualele infecții sau anemii). Glicemie (pentru a verifica riscul de diabet, care poate afecta sănătatea orală).</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info7_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info7_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Tomografie computerizată (CBCT) - pentru o evaluare tridimensională detaliată a structurilor maxilo-faciale.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info8_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info8_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Fotografia intraorală - pentru documentare și comunicare cu pacientul.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info9_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info9_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Test genetic - pentru identificarea predispoziției la afecțiuni dentare, cum ar fi boala parodontală.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info10_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info10_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->
        <!--        <tr>-->
        <!--            <td>Orice alta investigatie.</td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info11_8,  "X", false)}}</b></td>-->
        <!--            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info11_8,  "X", true)}}</b></td>-->
        <!--        </tr>-->

        <tr class="leftAlignHead">
            <td>9. Suferiți de afecțiuni care vă afectează discernământul ?</td>
            <td>DA</td>
            <td>NU</td>
        </tr>
        <tr>
            <td></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_9,  "X", false)}}</b></td>
            <td><b>{{getBooleanFieldData(AcordPacientInformatFieldNames.API_SB_V2__info1_9,  "X", true)}}</b></td>
        </tr>
        <ng-container *ngIf="accepted()">
            <tr class="leftAlignHead">
                <td colspan="3">I) ACCEPT EFECTUAREA ACTULUI MEDICAL</td>
            </tr>
            <tr>
                <td colspan="3">
                    <p>
                        I) Subsemnatul / (a) <b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_prenumePacient)}} {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_numePacient)}}*</b> declar că
                        am înțeles toate informațiile furnizate de către <b>{{getMedicName()}}**</b>,
                        mai sus-enumerate, că am prezentat medicului / asistentului medical doar informații adevărate și că îmi
                        exprim acordul informat pentru efectuarea actului medical și totodată îmi exprim acordul informat asupra
                        riscurilor potențiale sau imprevizibile asociate actului medical efectuat.<br>
                        * Numele și prenumele pacientului / reprezentantului legal<br>
                        ** Numele și prenumele medicului / asistentului medical care a informat pacientul
                    </p>
                </td>
            </tr>
            <tr>
                <td>
                    Semnătura pacientului / reprezentantului legal care consimte informat la efectuarea
                    actului medical<br>
                    <div class="max-w-48"><img [src]="getSignatureBlobURL()"></div>
                </td>
                <td>
                    Data:
                    {{ getSignedDate()}}
                </td>
                <td>
                    Ora:
                    {{ getSignedHour() }}
                </td>
            </tr>
        </ng-container>

        <ng-container *ngIf="!accepted()">
            <tr class="leftAlignHead">
                <td colspan="3">II) REFUZ EFECTUAREA ACTULUI MEDICAL</td>
            </tr>
            <tr>
                <td colspan="3">
                    <p>
                        II) Subsemnatul / (a) <b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_prenumePacient)}} {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_numePacient)}}*</b> declar că
                        am înțeles toate informațiile furnizate de către <b>{{getMedicName()}}**</b>,
                        mai sus-enumerate, că mi s-au explicat consecințele refuzului actului medical și că îmi exprim refuzul
                        pentru efectuarea actului medical.<br>
                        * Numele și prenumele pacientului / reprezentantului legal<br>
                        ** Numele și prenumele medicului / asistentului medical care a informat pacientul
                    </p>
                </td>
            </tr>
            <tr>
                <td>
                    Semnătura pacientului / reprezentantului legal care refuză efectuarea actului
                    medical <br>
                    <div class="max-w-48"><img [src]="getSignatureBlobURL()"></div>
                </td>
                <td>
                    Data:
                    {{ getSignedDate()}}
                </td>
                <td>
                    Ora:
                    {{ getSignedHour()}}
                </td>
            </tr>
        </ng-container>
    </table>


</div>
